import styled from 'styled-components';
import { rem, em } from 'polished';
import { colors, duration, ease } from 'core/theme';
import { media } from 'core/layout';

export const MenuWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 500;

    pointer-events: ${({menuOpen}) => menuOpen ? 'auto' : 'none'};

    & > div {
        padding: 0;

        transition: transform ${duration.normal} ${ease.standard};
        transform: ${({menuOpen}) => menuOpen ? 'translateX(0)' : 'translateX(-100%)'};

        ${media.tabletSmall`
          transition-duration: ${duration.fast};
        `};

        & > div {
            margin: 0;
        }
    }

    &::before {
        content: '';
        display: block;
        background-color: ${colors.B38A};
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100vh;

        transition: opacity ${duration.normal} ${ease.standard};
        opacity: ${({menuOpen}) => menuOpen ? 1 : 0};
    }
`;

export const StyledMobileMenu = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: ${colors.background};
    border-right: 1px solid ${colors.hairline};
    width: 100%;
    height: 100vh;

    &::before {
        content: '';
        display: block;
        background-color: ${colors.background};
        height: 100%;

        position: absolute;
        top: 0;
        width: calc((100vw - 1280px) / 2);
        /* NOTE: left izmantots, jo IE11 nesaprot calc iekš transform */
        left: calc((100vw - 1280px) / -2);
    }

    & > div {
      max-height: 100%;
      overflow-y: auto;
      padding-bottom: 5em;
    }

    hr {
      position: relative;
      width: calc(100% + (100vw - 1280px) / 2);
      left: calc((100vw - 1280px) / -2);
    }

    ${media.site`
      &::before,
      hr {
        width: auto;
        left: 0;
      }
    `};

    ${media.tabletSmall`
      border-right: 0;
    `};
`;

export const TopGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1em;
    min-height: ${rem(65)};
    height: 0; /* IE flex fix */
    position: relative;

    button {
      outline-offset: -2px !important;
    }

    padding-left: 60px;
    ${media.tablet`
      padding-left: 32px;
    `};

    ${media.tabletSmall`
      padding-left: 20px;
    `};

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: ${colors.hairline};
      height: 1px;
      width: calc(100% + (100vw - 1280px) / 2);
      left: calc((100vw - 1280px) / -2);
    }

    ${media.site`
      &::after {
        width: auto;
        left: 0;
      }
    `};
`;

export const VisibleOnMobile = styled.div`
  @media (min-width: 721px) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/modules/Header/components/MobileMenu/styled.js